export enum BasicInfoTrackerName {
  FinancingRequest = "FinancingRequest",
  SchoolCarriers = "SchoolCarriers",
  AuthorizedCarriers = "AuthorizedCarriers"
}

export default BasicInfoTrackerName;
